<template>
  <div class="ec-line010" v-loading="loading">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <a :href="baseUrl">{{ this.shopName }}</a></el-breadcrumb-item
      >
      <el-breadcrumb-item :to="{ path: $routePage.EC_LINE009 }"> {{ $t('ec-line009.heading') }}</el-breadcrumb-item>
      <el-breadcrumb-item> {{ $t('ec-line010.title') }}</el-breadcrumb-item>
    </el-breadcrumb>
    <the-heading class="mb-5 lg:mb-8">{{ $t('ec-line010.title') }}</the-heading>
    <member-information
      v-if="form"
      v-model="form"
      :before-change-phone-number="beforeChangePhoneNumber"
      :corporate-flag="corporateFlag"
      @submit="onSubmit"
      @cancel="onCancel"
    ></member-information>
    <confirm-dialog-2
      :visible="confirmVisible"
      :title="$t('ec-line010.content.updateSuccess.title')"
      :acceptText="$t('ec-line010.content.updateSuccess.toSubscription')"
      btn-class="whitespace-pre-wrap py-1"
      @accept="onAccept"
      @close="onCancel"
    >
      <template #content>
        <p v-html="$t('ec-line010.content.updateSuccess.content')"></p>
      </template>
    </confirm-dialog-2>
  </div>
</template>

<script>
import TheHeading from '@/components/my-page-partials/TheHeading.vue'
import MemberInformation from '@/components/ec-line010/MemberInformation.vue'
import { AuthService } from '@/services'
import { getAuth } from '@/router/func'
import BreadcrumbMixin from '@/mixins/breadcrumb'
import ConfirmDialog2 from '@/components/ConfirmDialog2.vue'

export default {
  components: { TheHeading, MemberInformation, ConfirmDialog2 },
  mixins: [BreadcrumbMixin],
  data() {
    return {
      form: null,
      loading: false,
      confirmVisible: false,
    }
  },
  computed: {
    corporateFlag() {
      return this.$store.getters['auth/shop']?.corporate_flag
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true

      const { data } = await AuthService.me()

      const postalPattern = /(\d{3})[-]?(\d+)/
      const match = data.postal_code.match(postalPattern)
      const birth = data.birth && new Date(data.birth * 1000)
      this.form = {
        id: data.id,
        name01: data.name01,
        name02: data.name02,
        kana01: data.kana01,
        kana02: data.kana02,
        email: data.email,
        email_confirm: data.email,
        sex: data.sex?.id || null,
        postal_code: '-',
        postal_code01: match?.[1] || '',
        postal_code02: match?.[2] || '',
        pref_id: data.pref.id,
        addr01: data.addr01,
        addr02: data.addr02,
        addr03: data.addr03,
        birthday_year: birth?.getFullYear(),
        birthday_month: (birth && birth.getMonth() + 1) || null,
        birthday_day: birth?.getDate(),
        phone_number: this.Utils.helper.getOnlyNumber(data.phone_number),
        customer_status_id: data.customer_status_id,
        company_name: this.corporateFlag
          ? data.company_name
          : data.business_account_flag
          ? data.name01 + (data.name02 || '')
          : '',
        company_name_kana: data.business_account_flag ? data.kana01 + (data.kana02 || '') : '',
        store_name: data.store_name,
        business_account_flag: data.business_account_flag,
      }
      this.beforeChangePhoneNumber = this.Utils.helper.getOnlyNumber(data.phone_number)

      this.loading = false
    },
    onSubmit() {
      this.loading = true

      if (!this.corporateFlag && this.form.business_account_flag) {
        this.form.name01 = this.form.company_name
        this.form.name02 = ''
        this.form.kana01 = this.form.company_name_kana
        this.form.kana02 = ''
      }

      AuthService.updateInfo(this.form.id, {
        name01: this.form.name01,
        name02: this.form.name02,
        kana01: this.form.kana01,
        kana02: this.form.kana02,
        email: this.form.email,
        sex_id: this.form.sex,
        postal_code: `${this.form.postal_code01}-${this.form.postal_code02}`,
        pref_id: this.form.pref_id,
        addr01: this.form.addr01,
        addr02: this.form.addr02,
        addr03: this.form.addr03,
        phone_number: this.form.phone_number,
        birth:
          (this.form.birthday_year &&
            this.form.birthday_month &&
            this.form.birthday_day &&
            this.Utils.date.getDateString(
              new Date(`${this.form.birthday_year}/${this.form.birthday_month}/${this.form.birthday_day}`)
            )) ||
          undefined,
        customer_status: this.form.customer_status_id,
        store_name: this.form.store_name,
        company_name: this.corporateFlag ? this.form.company_name : '',
      })
        .then(() => getAuth())
        // .then(() => this.$alert({ message: this.$t('ec-line010.content.updateInfoSucces'), type: 'success' }))
        // .then(() => this.onCancel())
        .then(() => (this.confirmVisible = true))
        .catch((error) => this.handleError(error))
        .finally(() => (this.loading = false))
    },
    onAccept() {
      this.$router.push(this.$routePage.EC_LINE014)
    },
    onCancel() {
      this.$router.push(this.$routePage.EC_LINE009)
    },
  },
  metaInfo() {
    return {
      title: this.$t('ec-line010.title'),
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.$t('ec-line010.description', { shop_name: this.shopName }),
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: this.$t('ec-line010.keyword', { shop_name: this.shopName }),
        },
      ],
    }
  },
}
</script>

<style></style>
